import { render, staticRenderFns } from "./AddKei.vue?vue&type=template&id=fcdc6048"
import script from "./AddKei.vue?vue&type=script&lang=js"
export * from "./AddKei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports